// 홈 3칸 KPI 타일 — 시안 A1 `.kpi .k`. props: { label, count, tone:'accent'|'warn'|'ink', onClick }
// tone='warn' 이면 앰버 카드(결정 대기 ≥1). count 는 0 이어도 '0' 으로 렌더한다(숨기지 않는다).
import React from 'react';
import { T, R, FONT } from '../../theme';
import LtrText from './LtrText';

var base = {
  background: T.card, borderRadius: R.card, padding: '12px 13px', display: 'flex', alignItems: 'center',
  gap: 10, textAlign: 'start', minWidth: 0, width: '100%', boxSizing: 'border-box', fontFamily: 'inherit'
};
var numBase = { fontSize: 23, fontWeight: 800, letterSpacing: '-.6px', lineHeight: 1, minWidth: 24 };
// 라벨은 줄바꿈 허용 — 390px 3열에서 en/ar/ru 가 nowrap+ellipsis 로 잘렸다(V D2).
var labelBase = { fontSize: FONT.body, fontWeight: 700, minWidth: 0, lineHeight: 1.25, overflowWrap: 'break-word' };

function KpiTile(props) {
  var warn = props.tone === 'warn';
  var style = Object.assign({}, base, {
    border: '1px solid ' + (warn ? T.warnBd : T.bd),
    background: warn ? T.warnTint : T.card,
    cursor: props.onClick ? 'pointer' : 'default'
  });
  var color = props.tone === 'accent' ? T.accent : warn ? T.warn : T.ink;
  return (<button type="button" className="ss-kpi" style={style} onClick={props.onClick}>
    <LtrText style={Object.assign({}, numBase, { color: color })}>{Number(props.count || 0)}</LtrText>
    <span style={Object.assign({}, labelBase, { color: warn ? T.warn : T.muted })}>{props.label}</span>
  </button>);
}

export default KpiTile;
